import { SmartQuoteAction } from 'models';
import { logAnalytics } from 'shared/middlewares/analytics/logger';

export function trackSmartQuoteEvent<E extends keyof SmartQuoteAction>(event: E, name: SmartQuoteAction[E]) {
  logAnalytics.trackEvent('Primary market smart quote', event, name);
}
